import request from '@/utils/request'

// 业务登录
export function login(data) {
  return request({
    url: '/v2/promotion/salesman/login',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function verificationCodes(data) {
  return request({
    url: '/v2/public/customers/sms/verification-codes',
    method: 'post',
    data
  })
}

// 业务商户列表
export function getMerchants(params) {
  return request({
    url: '/v2/promotion/salesman/merchants',
    method: 'get',
    params
  })
}

// 业务佣金列表
export function getCommisionOrders(data) {
  return request({
    url: '/v2/promotion/salesman/commision-orders',
    method: 'post',
    data
  })
}

// 业务佣金总览
export function getCommisionSummary(data) {
  return request({
    url: '/v2/promotion/salesman/commision-summary',
    method: 'post',
    data
  })
}

// 商品列表
export function getProducts() {
  return request({
    url: '/v2/promotion/products',
    method: 'get',
  })
}
